import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterNone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.33398 11.9999C4.96732 11.9999 4.65343 11.8694 4.39232 11.6083C4.13121 11.3471 4.00065 11.0333 4.00065 10.6666V2.66659C4.00065 2.29992 4.13121 1.98603 4.39232 1.72492C4.65343 1.46381 4.96732 1.33325 5.33398 1.33325H13.334C13.7007 1.33325 14.0145 1.46381 14.2757 1.72492C14.5368 1.98603 14.6673 2.29992 14.6673 2.66659V10.6666C14.6673 11.0333 14.5368 11.3471 14.2757 11.6083C14.0145 11.8694 13.7007 11.9999 13.334 11.9999H5.33398ZM2.66732 14.6666C2.30065 14.6666 1.98676 14.536 1.72565 14.2749C1.46454 14.0138 1.33398 13.6999 1.33398 13.3333V3.99992H2.66732V13.3333H12.0007V14.6666H2.66732Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFilterNone);
export default ForwardRef;
